import { call, put, takeLatest } from 'redux-saga/effects';

import { setShipperUsers, setShipperAddresses, appendShipperAddresses, setReset } from './duck';

import { handleQuote } from './quote';

import { fetchAddresses } from 'redux/modules/addresses/effects';

import { setUserSettings } from 'redux/modules/shipper-order-form/utils';

export const formChange$ = 'shipper-order-form/formChange$';
export const addAddress$ = 'shipper-order-form/addAddress$';
export const clearForm$ = 'shipper-order-form/clearForm$';

const shipperChange$ = 'shipper-order-form/shipperChange$';
const userChange$ = 'shipper-order-form/userChange$';

export const formChange = (form) => ({
  type: formChange$,
  payload: form,
});

export const shipperChange = ({ shipper, setValues, setFieldValue, values }) => ({
  type: shipperChange$,
  payload: {
    shipper,
    setValues,
    setFieldValue,
    values,
  },
});

export const userChange = ({ user }) => ({
  type: userChange$,
  payload: {
    user,
  },
});

export const addAddress = (address) => ({
  type: addAddress$,
  payload: {
    address,
  },
});

export const clearForm = () => ({
  type: clearForm$,
  payload: {},
});

function* handleShipperChange({ payload }) {
  const { shipper, setFieldValue, setValues, values } = payload;

  const { shipments } = values;

  yield call(setValues, {
    ...values,
    user: undefined,
    shipments: shipments.map((shipment) => ({
      ...shipment,
      address_from: null,
      address_to: null,
    })),
  });

  const { users = [] } = shipper || {};

  const shipperUsers = users;
  yield put(setShipperUsers(shipperUsers));

  if (shipperUsers.length === 1) {
    const firstUser = shipperUsers[0] || {};
    yield call(setFieldValue, 'user', firstUser);
    yield call(setUserSettings, firstUser);
  }

  const addresses = yield call(fetchAddresses, shipper);
  yield put(setShipperAddresses(addresses));
}

function* handleUserChange({ payload }) {
  const { user } = payload;
  yield call(setUserSettings, user);
}

function* handleAddressCreation({ payload }) {
  const { address } = payload;
  yield put(appendShipperAddresses([address]));
}

function* handleClear() {
  yield put(setReset());
}

// Watchers
export function* watchShipperOrderForm() {
  yield takeLatest(shipperChange$, handleShipperChange);
  yield takeLatest(userChange$, handleUserChange);
  yield takeLatest(addAddress$, handleAddressCreation);
  yield takeLatest(formChange$, handleQuote);
  yield takeLatest(clearForm$, handleClear);
}
